(function($) {
	$(function () {

        $('.js-spoiler').each(function () {
            initSpoiler($(this))
        })

        function initSpoiler($spoiler) {
            const $trigger = $spoiler.find('.js-spoiler-trigger')
            const $content = $spoiler.find('.js-spoiler-content')
            $trigger.on('click', function() {
                if ($spoiler.is('[data-expanded')) {
                    $spoiler.removeAttr('data-expanded')
                    $content.stop().slideUp()
                    return
                }
                $spoiler.attr('data-expanded', true)
                $content.stop().slideDown()
            })
        }

	})
})(window.jQuery)
